import { Icon, Text } from "@/components"
import { useStyles } from "@/components/PlaceholderButton/PlaceholderButton.style"
import { Select } from "@mantine/core"
import { useClickOutside } from "@mantine/hooks"
import React, { useRef, useState } from "react"
import { flushSync } from "react-dom"

interface WrapperProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: string
}

interface Props {
    onClick: (text: string) => void
    placeholders: Array<{
        slug: string
        value: string
        name: string
    }>
    /** Usage: <PlaceholderButton Wrapper={(props) => <Button variant="outline" {...props}/>} */
    Wrapper: (props: WrapperProps) => JSX.Element
    disabled?: boolean
}

export const PlaceholderButton = ({ onClick, placeholders, Wrapper, disabled }: Props) => {
    const { classes } = useStyles({ disabled })
    const [isActive, setIsActive] = useState(false)

    const selectWrapperRef = useClickOutside(() => setIsActive(false))
    const selectRef = useRef(null)

    const handleOnChange = (value: string) => {
        setIsActive(!isActive)
        onClick(value)
    }

    const toggleSelect = () => {
        if (disabled) return
        flushSync(() => setIsActive(!isActive)) //focus must happen after rerender, otherwise it has no effect
        selectRef.current?.focus()
    }

    return (
        <div ref={selectWrapperRef} className={classes.wrapper}>
            <Wrapper className={classes.buttonWrapper} onClick={toggleSelect}>
                <div className={classes.buttonLabelWrapper}>
                    <Icon className={classes.buttonIcon} icon="plus" iconFamily="far" color="black" />
                    <Text className={classes.buttonText}>Insert Placeholder</Text>
                </div>
            </Wrapper>
            {isActive && (
                <Select
                    ref={selectRef}
                    id="select-id"
                    classNames={{ root: classes.select, item: classes.item }}
                    name="Search placeholder"
                    clearable
                    allowDeselect
                    onChange={handleOnChange}
                    initiallyOpened
                    searchable
                    placeholder="Search placeholders..."
                    data={placeholders.map((placeholder) => ({ value: placeholder.value, label: placeholder.name }))}
                    rightSection={<></>}
                />
            )}
        </div>
    )
}
